import { render } from "./BaseBotaoAcao.vue?vue&type=template&id=cea0b2b2&scoped=true"
import script from "./BaseBotaoAcao.vue?vue&type=script&lang=js"
export * from "./BaseBotaoAcao.vue?vue&type=script&lang=js"

import "./BaseBotaoAcao.vue?vue&type=style&index=0&id=cea0b2b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cea0b2b2"]])

export default __exports__